// src/auth/authProvider.js
// Wraps the entire app with MsalProvider so any component
// can access the signed-in user and request tokens.

import React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./msalConfig";

// Create the MSAL instance once — do not recreate on every render
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialise MSAL — must be called before rendering
// Handles redirect responses from Azure AD
export async function initializeMsal() {
  await msalInstance.initialize();
  // Handle the redirect response if returning from Azure AD login
  await msalInstance.handleRedirectPromise();
}

export function AuthProvider({ children }) {
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
}